import React, { useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import SuccessPopup from '../../components/SuccessPopup/SuccessPopup';
import { setCurrentUser } from '../../C2wStore/actions';
import './LoginPage.css';

function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cardRef = useRef(null);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const handleOverlayClick = (e) => {
    if (cardRef.current && !cardRef.current.contains(e.target)) {
      handleClose();
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    try {
      // Fetch existing users from localStorage
      const existingUsers = JSON.parse(localStorage.getItem('users')) || [];
      
      // Find matching user
      const matchedUser = existingUsers.find(
        (user) => user.username === formData.username && user.password === formData.password
      );

      if (matchedUser) {
        // Login successful
        localStorage.setItem('sessionUser', JSON.stringify(matchedUser));
        dispatch(setCurrentUser(matchedUser));
        setShowSuccess(true);
      } else {
        // Login failed
        toast.error("Invalid username or password");
      }
    } catch (error) {
      toast.error("An error occurred during login: " + error.message);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate('/');

  };

  return (
    <>
      <div className='LoginPage_ctn' onClick={handleOverlayClick}>
        <div className='LoginPage_card' ref={cardRef}>
          <button 
            type="button" 
            className="LoginPage_close_btn" 
            onClick={handleClose} 
            aria-label="Close"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div className='LoginPage_heading'>Login</div>
          <form className='LoginPage_form' onSubmit={handleSubmit}>
            <input 
              type="text" 
              name="username" 
              placeholder='Username' 
              value={formData.username} 
              onChange={handleChange} 
              required 
            />
            
            <div className="LoginPage_password_wrapper">
              <input 
                type={showPassword ? "text" : "password"} 
                name="password" 
                placeholder='Password' 
                value={formData.password} 
                onChange={handleChange} 
                required 
              />
              <span 
                className="LoginPage_eye_icon" 
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                )}
              </span>
            </div>

            <div className="LoginPage_forgot_password">
              <span onClick={() => console.log('Forgot password clicked')}>Forgot password?</span>
            </div>

            <button type="submit">Login</button>
          </form>
          <div className="LoginPage_footer">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </div>
        </div>
      </div>
      {showSuccess && (
        <SuccessPopup 
          message="You have logged in successfully." 
          onClose={handleSuccessClose} 
        />
      )}
    </>
  );
}

export default LoginPage;
